import Model from "flarum/Model";

export default class U2DiInfoBase extends Model {}
Object.assign(U2DiInfoBase.prototype, {
  id: Model.attribute("id"),
  sn: Model.attribute("sn"),
  name: Model.attribute("name"),
  type: Model.attribute("type"),
  category: Model.attribute("category"),
  lat: Model.attribute("lat"),
  lng: Model.attribute("lng"),
  views: Model.attribute("views"),
  distributes: Model.attribute("distributes"),
  queries: Model.attribute("queries"),
  status: Model.attribute("status"),
  import: Model.attribute("import"),
  province: Model.attribute("province"),
  city: Model.attribute("city"),
  price: Model.attribute("price"),
  signed: Model.attribute("signed"),
  signedMark: Model.attribute("signedMark"),
  promoted: Model.attribute("promoted"),
  note: Model.attribute("note"),
  attachment: Model.attribute("attachment"),
  reports: Model.attribute("reports"),
  userType: Model.attribute("userType"),
  userID: Model.attribute("user_id"),
  flag: Model.attribute("flag"),
  jjType: Model.attribute("jjType"),
  bilibiliLink: Model.attribute("bilibiliLink"),
  distributeID: Model.attribute("distributeID"),
  nID: Model.attribute("nid"),
  assignedAt: Model.attribute("assignedAt"),
  publicAt: Model.attribute("publicAt"),
  u2diUserData: Model.hasOne("u2diUserData"),
  u2diDetailsData: Model.hasOne("u2diDetailsData"),
  u2diQueriesData: Model.hasOne("u2diQueriesData"),
  u2diReportData: Model.hasMany("u2diReportData"),
});